export const STAGE = {
    ADMISSIONS: {
        id: 'ADMISSIONS',
        name: 'Admissions'
    },
    RETENTION: {
        id: 'RETENTION',
        name: 'Retention'
    }
}
